// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2697":"51814016ec5db566","4888":"0ffc3e306a4b89e4"}[chunkId] + ".css";
};